import { useCallback } from 'react';
import { useFetch } from './use-fetch';

export const useDownloadFile = () => {
    const fetch = useFetch();

    return useCallback(async (url, filename) => {
        const response = await fetch(url);
        if (!response.ok) {
            alert('Something went wrong...');
            return false;
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        return true;
    }, [fetch]);
};

export const useDownloadFirmwareFile = () => {
    const downloadFile = useDownloadFile();

    return useCallback(async (firmwareId, firmawareFile, filename) => {
        const url = `${import.meta.env.VITE_BASE_ADMIN_API_URL}/firmwares/download/${firmwareId}/${firmawareFile}`;
        return downloadFile(url, filename);
    }, [downloadFile]);
};
